<template>
  {{ $t('branch.list') }} <MapPinIcon class="w-4 h-4 ml-2 mr-2" />
  <LoadingIcon icon="three-dots" class="w-8 h-8" v-show="loading" />
  <ul v-show="!loading">
    <template v-for="branch in branches" :key="branch.uuid">
      <li v-if="this.selectedBranches.includes(branch.uuid)">
        <router-link
          :to="{
            name: 'side-menu-branches-detail',
            params: { uuid: branch.uuid }
          }"
          tag="a"
        >
          <ArrowUpLeftIcon class="w-4 h-4 mr-1 ml-2" />
          {{ branch.title }}
        </router-link>
      </li>
    </template>
  </ul>
</template>

<script>
import { defineComponent } from 'vue'
import branchApi from '../../services/branches/branch.api'

export default defineComponent({
  data() {
    return {
      branches: [],
      loading: true
    }
  },
  mounted() {
    branchApi.getList(1, 100).then(
      response => {
        this.branches = response.data.data
        this.loading = false
      },
      error => {
        console.log(error)
        this.loading = false
      }
    )
  },
  props: {
    selectedBranches: {
      type: Array,
      default: () => []
    }
  }
})
</script>
